// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inner_mapping_obj {
  border: 1px solid var(--rm-border);
  padding: 8px 14px;
  background-color: var(--rm-surface);
  border-radius: var(--rm-radius);
  color: var(--rm-text);
  margin: 4px 8px 4px 4px;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
  transition: background-color var(--rm-transition), color var(--rm-transition), border-color var(--rm-transition), box-shadow var(--rm-transition);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.inner_mapping_obj:hover {
  background-color: var(--rm-primary);
  color: #fff;
  border-color: var(--rm-primary);
  box-shadow: 0 2px 6px var(--rm-primary-dim);
}

.nested-info {
  border-left: 2px solid var(--rm-border);
  padding: 2px 0 2px 8px;
  margin-left: 16px;
  background: none;
  font-size: 13px;
}

.value .inner_mapping_inner {
  border: 1px solid var(--rm-primary-border);
  padding: 6px 12px;
  background-color: var(--rm-primary-dim);
  border-radius: var(--rm-radius);
  margin: 3px;
  text-align: center;
  color: var(--rm-text);
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/ObjectRenderer.scss"],"names":[],"mappings":"AAAA;EACI,kCAAA;EACA,iBAAA;EACA,mCAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iJAAA;EACA,yCAAA;AACJ;AACI;EACI,mCAAA;EACA,WAAA;EACA,+BAAA;EACA,2CAAA;AACR;;AAGA;EACI,uCAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAAJ;;AAII;EACI,0CAAA;EACA,iBAAA;EACA,uCAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AADR","sourcesContent":[".inner_mapping_obj {\r\n    border: 1px solid var(--rm-border);\r\n    padding: 8px 14px;\r\n    background-color: var(--rm-surface);\r\n    border-radius: var(--rm-radius);\r\n    color: var(--rm-text);\r\n    margin: 4px 8px 4px 4px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    font-size: 13px;\r\n    transition: background-color var(--rm-transition), color var(--rm-transition), border-color var(--rm-transition), box-shadow var(--rm-transition);\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n\r\n    &:hover {\r\n        background-color: var(--rm-primary);\r\n        color: #fff;\r\n        border-color: var(--rm-primary);\r\n        box-shadow: 0 2px 6px var(--rm-primary-dim);\r\n    }\r\n}\r\n\r\n.nested-info {\r\n    border-left: 2px solid var(--rm-border);\r\n    padding: 2px 0 2px 8px;\r\n    margin-left: 16px;\r\n    background: none;\r\n    font-size: 13px;\r\n}\r\n\r\n.value {\r\n    .inner_mapping_inner {\r\n        border: 1px solid var(--rm-primary-border);\r\n        padding: 6px 12px;\r\n        background-color: var(--rm-primary-dim);\r\n        border-radius: var(--rm-radius);\r\n        margin: 3px;\r\n        text-align: center;\r\n        color: var(--rm-text);\r\n        font-size: 13px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
